import { Component, OnInit } from '@angular/core';
const packageJson = require('../../../../package.json');
import { environment } from '../../../environments/environment';

@Component({
  selector: 'esc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public webtoolVersion = packageJson.version;
  public qaVersioning = packageJson.qaVersion;

  constructor() { }

  ngOnInit() {
    if (!environment.production) {
      this.webtoolVersion = this.webtoolVersion + "." +  this.qaVersioning;
      console.log("INSTANCE:" + environment.instance)
    }
  }

}
